<template>
  <v-container v-if="posts.length">
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <static-page-content slug="blog" />
      </v-flex>
    </v-layout>
    <v-layout row wrap :class="['blogposts-list']" align-space-between fill-height>
      <v-flex lg4 md6 sm12 xs12 :class="['pa-2', 'blogpost-item']" v-for="(post, index) in posts" :key="index">
        <v-card @click.capture="gtagEvent('view', 'blogpost', post.title.rendered)" ripple :to="`/blog/${post.slug}`" :title="$lang.continueReading(post.title.rendered)" :class="['full-height']">
          <v-img :src="post.image" aspect-ratio="1.7778" :lazy-src="$config.replacementImage" />
          <v-card-title v-html="post.title.rendered" />
          <v-divider />
          <v-card-text>
            <span v-html="post.excerpt.rendered" />
            <router-link :class="['white--text']" :to="`/blog/${post.slug}`" :title="$lang.continueReading(post.title.rendered)">
              [{{ $lang.continueReading().toLowerCase() }}...]
            </router-link>
          </v-card-text>
        </v-card>
      </v-flex>
      <featured-video />
    </v-layout>
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'BlogPage',
  mixins: [
    methods
  ],
  data () {
    return {
      posts: []
    }
  },
  mounted () {
    this.getPosts()
  }
}
</script>
<style>
.blogposts-list .more-link
{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/blog.vue